<template>
  <div>
    <div class="subtitle-1 font-weight-bold ml-2 my-2">
      Delete Cloud Recordings
    </div>
    <DeleteCloudRecordings :exid="cameraDialogStore.camera.exid" />
    <div v-if="canShowDecommissionCamera">
      <v-divider class="my-2" />
      <div class="subtitle-1 font-weight-bold ml-2 my-2">
        Decommission Camera
      </div>
      <DecommissionCamera />
    </div>
    <div v-if="canShowRestoreCamera">
      <v-divider class="my-2" />
      <div class="subtitle-1 font-weight-bold ml-2 my-2">Restore Camera</div>
      <RestoreCamera />
    </div>
    <v-divider class="my-2" />
    <div class="subtitle-1 font-weight-bold ml-2 my-2">Delete Camera</div>
    <DeleteCameraDialog />
  </div>
</template>

<script>
import DeleteCloudRecordings from "@/components/cameraTabs/DeleteCloudRecordings"
import DeleteCameraDialog from "@/components/cameras/DeleteCameraDialog"
import DecommissionCamera from "@/components/cameras/DecommissionCamera"
import RestoreCamera from "@/components/cameras/RestoreCamera"
import { mapStores } from "pinia"
import { useCameraDialogStore } from "@/stores/cameraDialog"
import { PERMISSIONS } from "@/constants/permissions"
import { CameraStatus } from "@evercam/shared/types/camera"

export default {
  components: {
    DeleteCameraDialog,
    DeleteCloudRecordings,
    DecommissionCamera,
    RestoreCamera,
  },
  computed: {
    ...mapStores(useCameraDialogStore),
    canShowRestoreCamera() {
      return (
        this.cameraDialogStore.camera?.status === CameraStatus.Decommissioned &&
        this.$permissions.user.can(PERMISSIONS.CAMERAS.RESTORE)
      )
    },
    canShowDecommissionCamera() {
      return (
        this.cameraDialogStore.camera?.status !== CameraStatus.Decommissioned &&
        this.$permissions.user.can(PERMISSIONS.CAMERAS.DECOMMISSION)
      )
    },
  },
}
</script>
